import { render, staticRenderFns } from "./reserve.vue?vue&type=template&id=17edcb36&scoped=true&"
import script from "./reserve.vue?vue&type=script&lang=js&"
export * from "./reserve.vue?vue&type=script&lang=js&"
import style0 from "./reserve.vue?vue&type=style&index=0&id=17edcb36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17edcb36",
  null
  
)

export default component.exports